<div class="tw-flex tw-flex-row tw-flex-wrap" fxLayoutAlign="end center">
  <mat-card-actions *ngIf="cancelDispFlg" class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn"
      (click)="onClickRegist('解約')" [disabled]="registContractForm.invalid">
      解約
    </button>
  </mat-card-actions>

  <mat-card-actions *ngIf="deleteDispFlg" class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn"
      (click)="onClickCancel()">
      取消
    </button>
  </mat-card-actions>

  <mat-card-actions *ngIf="approveDispFlg" class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn"
      (click)="onClickRegist('承認')" [disabled]="approveAuthFlg">
      承認
    </button>
  </mat-card-actions>

  <mat-card-actions *ngIf="createDispFlg" class="btn_area_right">
    <button type="submit" mat-raised-button color="primary" class="btn"
      (click)="onClickRegist('登録')" [disabled]="registContractForm.invalid">
      登録
    </button>
  </mat-card-actions>
</div>

<div class="tw-flex tw-flex-row tw-flex-wrap" fxLayoutAlign="end center">
  <mat-card-actions *ngIf="canceledDispFlg" class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn"
      (click)="onClickCansel()">
      キャンセル
    </button>
  </mat-card-actions>
  <mat-card-actions *ngIf="backDispFlg" class="btn_area_right">
    <button type="button" mat-raised-button color="primary" class="btn"
      (click)="goToPrevious()">
      戻る
    </button>
  </mat-card-actions>
</div>
